module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationSingaporeHero.d850c840.jpg";